import { DeviceType } from '@allesauto/utils/consts';
import { sbEditable } from '@storyblok/storyblok-editable';
import React, { FC } from 'react';

import Carousel from '../carousel';
import Testimonial, { TestimonialProps } from '../testimonial';

export interface TestimonialCarouselProps {
  items: TestimonialProps[];
  component: string;
  _uid: string;
  _editable?: string;
}

const TestimonialCarousel: FC<
  React.PropsWithChildren<TestimonialCarouselProps>
> = (props) => {
  const { items } = props;

  return (
    <div {...sbEditable(props)} className="col-end-25 col-start-1">
      <Carousel
        itemsToScrollXLDesktop={1}
        itemsToScrollLDesktop={1}
        itemsToScrollMobile={1}
        itemsToScrollTablet={1}
        itemsMobile={1}
        itemsLDesktop={1}
        itemsXLDesktop={1}
        itemsTable={1}
        isInfinite={false}
        deviceType={DeviceType.MOBILE}
      >
        {items.map((item, index) => (
          <div className="lg:mx-[10%]" key={`testimonial-${index}`}>
            <Testimonial {...item} />
          </div>
        ))}
      </Carousel>
    </div>
  );
};

export default TestimonialCarousel;
